import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M48.1199 6.76C40.7299 1.35 32.0999 1.79992 30.5999 1.79992C29.0899 1.79992 20.4599 1.35 13.0799 6.76C6.8599 11.31 1.92992 22.0999 1.66992 43.5499C1.66992 43.5499 5.48991 42.54 6.80991 47.6L7.1799 49.58C7.1799 49.58 9.1699 41.11 9.9299 33.73C10.8099 25.14 10.4599 20.2799 14.6599 18.3099C17.9599 16.7699 22.6999 18.75 30.7299 18.75C38.7599 18.75 43.1299 16.7699 46.4299 18.3099C50.6299 20.2699 50.2799 25.14 51.1599 33.73C51.9199 41.12 53.9099 49.58 53.9099 49.58L54.3899 47.6C55.7099 42.54 59.5299 43.5499 59.5299 43.5499C59.2699 22.0999 54.3299 11.31 48.1199 6.76Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M28.9198 18.6501C28.9198 18.6501 25.8398 1.59 15.8198 5.33" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M31.4599 18.54C31.4599 18.54 30.0299 2.68989 23.4199 2.79989"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M29.9199 2.14003C29.9199 2.14003 32.4499 1.81001 32.5599 17.99" stroke={outline} strokeMiterlimit="10" />
      <path d="M41.2498 3.45996C41.2498 3.45996 35.0798 5.32999 34.5298 17.99" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M48.2998 6.31995C48.2998 6.31995 40.1498 7.19998 37.0698 18.98"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M49.7299 8.52001C49.7299 8.52001 41.6898 8.3 38.8298 18.76"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M54.0299 13.6899C54.0299 13.6899 47.5299 11.2699 42.6899 18.0899"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M57.4399 22.28C57.4399 22.28 54.4699 19.42 49.1799 21.62"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M58.6498 31.0899C58.6498 31.0899 54.9098 29.77 50.8298 31.42"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M59.2 35.9299C59.2 35.9299 55.13 34.8299 51.49 35.9299" stroke={outline} strokeMiterlimit="10" />
      <path d="M59.42 38.02C59.42 38.02 55.35 36.92 51.71 38.02" stroke={outline} strokeMiterlimit="10" />
      <path d="M12.96 6.31995C12.96 6.31995 21.11 7.19998 24.19 18.98" stroke={outline} strokeMiterlimit="10" />
      <path d="M7.23999 13.6899C7.23999 13.6899 13.74 11.2699 18.58 18.0899" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M3.81982 22.28C3.81982 22.28 6.7898 19.42 12.0798 21.62"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M2.60986 31.0899C2.60986 31.0899 6.34987 29.77 10.4299 31.42" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M2.05981 35.9299C2.05981 35.9299 6.12981 34.8299 9.76981 35.9299"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M1.83984 38.02C1.83984 38.02 5.90984 36.92 9.54984 38.02" stroke={outline} strokeMiterlimit="10" />
    </g>
  )
}
